import { useEffect } from 'react';
import {
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';

import {
  ANIMATED_DIALOG_ANIMATION_CONFIG,
  ANIMATED_DIALOG_ITEM_TRANSITION_DELAY,
} from '../../AnimatedDialog.constants';

export const useAnimatedDialogAnimation = (
  props: AnimatedDialogAnimationProps,
) => {
  const { show } = props;

  const opacitySV = useSharedValue(0);

  const animation = useAnimatedStyle(() => {
    return {
      opacity: opacitySV.value,
    };
  }, [opacitySV]);

  useEffect(() => {
    opacitySV.value = withDelay(
      ANIMATED_DIALOG_ITEM_TRANSITION_DELAY,
      withTiming(show ? 1 : 0, ANIMATED_DIALOG_ANIMATION_CONFIG),
    );
  }, [opacitySV, show]);

  return animation;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type AnimatedDialogAnimationProps = {
  show: boolean;
};
